import { type ChangeEvent, useCallback, useEffect, useState } from 'react';

import { twMerge } from 'tailwind-merge';

import type { RawInputProps } from '@/_components';
import { Input } from '@/_components';
import { useBoolean } from '@/_shared';

export function CellInput({
  className,
  onValueChange,
  ...props
}: RawInputProps & { onValueChange: (v: string) => boolean }) {
  const [hasIssue, setHasIssue] = useBoolean(false);
  const [value, setValue] = useState(props.value);

  // When the input is blurred, we'll call our table meta's updateData function
  const onBlur = () => {
    setHasIssue.set(!onValueChange(value as string));
  };

  const handleChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      setValue(e.target.value);
      setHasIssue.setFalse();
    },
    [setHasIssue]
  );
  // If the initialValue is changed external, sync it up with our state
  useEffect(() => {
    setValue(props.value);
  }, [props.value]);

  return (
    <Input
      {...props}
      value={value}
      onChange={handleChange}
      onBlur={onBlur}
      containerProps={{ className: 'h-6' }}
      className={twMerge('border-b-2 pt-0.5 pb-0.5 text-xs', hasIssue && '!dark:border-error border-error!', className)}
    />
  );
}
